import styled from "styled-components";

import HStack from "shared/components/layout/stack/HStack";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import { COLOR_VALUES } from "shared/config/colors";
import { mediaQueries } from "shared/config/breakpoints";

export const StyledPageHeadTitle = styled(Text)`
    font-feature-settings:
        "pnum" on,
        "lnum" on;
    ${({ $compact }) =>
        $compact &&
        `
        font-size: 26px;
        line-height: 34px;
    `}

    ${mediaQueries.small} {
        font-size: ${({ $compact }) => ($compact ? "1.4rem" : "2.25rem")};
        line-height: 1.4;
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: normal;
        max-width: 100%;
        margin-bottom: 4px;
        padding-right: 8px;
    }
`;

export const StyledListWrapper = styled(HStack)`
    gap: ${({ $compact }) => ($compact ? "12px" : "24px")};

    ${mediaQueries.small} {
        gap: 16px;
    }
`;

export const CompactInfoRow = styled(HStack)`
    flex-wrap: wrap;
`;

export const InfoSeparator = styled.span`
    color: ${COLOR_VALUES.Gray_4};
    user-select: none;
`;

export const ResponsivePageHeadWrapper = styled(VStack)`
    ${mediaQueries.small} {
        margin-top: 8px;
        position: relative;
        z-index: 1;
    }
`;
